/** 课程管理API */
import type { Api } from '@/typings/api';
import { post } from '../../request';
const prefix = '/school/lectureCourse';
/**
 * 分页查询课程管理
 *
 * @param params 查询参数
 */
export const findPage: Api.CommonMethods.FindPage<Api.School.LectureCourse> = params => {
  return post(`${prefix}/findPage`, params);
};
/**
 * 查询课程管理列表
 *
 * @param params 查询参数
 */
export const findAll: Api.CommonMethods.FindAll<Api.School.LectureCourse> = params => {
  return post(`${prefix}/findAll`, params);
};
/**
 * 查询单个课程管理
 *
 * @param id 课程管理ID
 * @param column 查询字段
 */
export const findOne: Api.CommonMethods.FindOne<Api.School.LectureCourse> = (id: string, column?: string[]) => {
  return post(`${prefix}/findOne`, { id, column });
};
/**
 * 保存课程管理
 *
 * @param params 课程管理信息
 */
export const doSave: Api.CommonMethods.Save = params => {
  return post(`${prefix}/save`, params);
};
/**
 * 更新课程管理信息
 *
 * @param params 课程管理信息
 */
export const doUpdate: Api.CommonMethods.Update = params => {
  return post(`${prefix}/update`, params);
};
/**
 * 删除课程管理
 *
 * @param id 课程管理ID
 */
export const doDelete: Api.CommonMethods.Delete = id => {
  return post(`${prefix}/delete?id=${id}`);
};
/**
 * 批量删除课程管理
 *
 * @param ids 课程管理ID数组
 */
export const doBatchDelete: Api.CommonMethods.BatchDelete = ids => {
  return post(`${prefix}/deleteList`, { ids });
};

export default {
  findPage,
  findOne,
  doSave,
  doUpdate,
  doDelete,
  doBatchDelete
};
